import { Map } from "immutable"

import {
    PROJECT_LIST_REQUEST as LIST_REQUEST,
    PROJECT_LIST_RESPONSE as LIST_RESPONSE,
    PROJECT_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    PROJECT_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

const defaultSearchCriteria = Map({
    name: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)
